import { Role } from '@personal-area/global/users/models';
import { SocialNetworksEnum } from '@personal-area/global/social-authorization/models';

export enum AuthGrantType {
  AuthorizationCode = 'authorization_code',
  RefreshToken = 'refresh_token',
}

export enum AuthMethod {
  Password = 'password',
  Social = 'social',
}

export interface BasicCredentials {
  email: string;
  password: string;
}

export interface SocialCredentials {
  type: SocialNetworksEnum;
  socialToken: string;
}

export interface CabinetAuthToken {
  accessToken: string;
  refreshToken: string;
  userId: number;
  role: Role;
}

export interface CodeState {
  code: string;
  state: string;
}

export interface AuthTokenRequest {
  grantType: AuthGrantType,
  method: AuthMethod;
  clientID: number;
  clientSecret: string;
  code: string;
  refreshToken?: string;
  basicCredentials?: BasicCredentials;
  socialCredentials?: SocialCredentials
}

export interface AuthTokenResponse {
  accessToken: string;
  tokenType: string;
  expiresIn: number; // TTL
  refreshToken: string;
  lastRoles: Role[];
  role: Role;
  userID: number; // roles used in apps which are different from current user app
}

export interface AuthToken extends AuthTokenResponse {
  usedAccountTypes: Role[];
  accessExpiresAt: number; // UTC timestamp
  refreshExpiresAt: number; // UTC timestamp
}

export interface LoginData extends AuthToken {
  isLoginAfterReg?: boolean;
}
